import React from 'react';
import styled from 'styled-components';
import { Card } from '@material-ui/core';

const ResizeCardPadBody = styled.div`
  background-color: #11ffee00;
`
interface CardContentCardProps {
  width: number;
  height: number;
}
const CardContentCard = styled(Card)<CardContentCardProps>`
  position: absolute;
  background-color: #11ffee00;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
  pointer-events: none;
`

type ResizeCardPadProps = {
  width: number;
  height: number;
}
const ResizeCardPad: React.FC<ResizeCardPadProps> = ({children, width, height}) => {
  return (
    <ResizeCardPadBody>
      <CardContentCard width={width} height={height}>
        { children }
      </CardContentCard>
    </ResizeCardPadBody>
  );
}

export default ResizeCardPad;
